import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { Avatar, Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import useStyles from '../indexcss';

interface ChatBoxProps {
  onClose: () => void;
}

const SupportTeamAvatar: React.FC<{ classes: any }> = ({ classes }) => <Avatar alt="ST" src="/path/to/support_team_avatar.jpg" className={classes.supportTeamAvatar} />;

const ChatBox: React.FC<ChatBoxProps> = ({ onClose }) => {
  const classes = useStyles();
  const [chatMessages, setChatMessages] = useState([
    {
      sender: 'Support Team',
      message: 'Hello! How can we assist you?',
    },
    {
      sender: 'You',
      message: 'Hi Support Team! I need help with an issue.',
    },
  ]);

  const [newMessage, setNewMessage] = useState('');

  const handleSendMessage = () => {
    if (newMessage.trim() !== '') {
      setChatMessages([...chatMessages, { sender: 'You', message: newMessage }]);
      setNewMessage('');
    }
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth className={classes.chatBox}>
      <DialogTitle style={{ padding: '0px', borderRadius: '12px' }}>
        <Box className={classes.headerContaine}>
          <Box display="flex" alignItems="center">
            <SupportTeamAvatar classes={classes} />
            <Typography className={classes.supportTeamName}>Support Team</Typography>
          </Box>
          <IconButton color="primary" onClick={onClose} aria-label="close" className={classes.closeButton}>
            <CloseOutlinedIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className={classes.chatMessagesContainer}>
        {chatMessages.map((message, index) => (
          <Paper key={index} className={message.sender === 'Support Team' ? classes.chatMessageAdmin : classes.chatMessageUser}>
            <Typography variant="subtitle2">{message.sender}</Typography>
            <Typography>{message.message}</Typography>
          </Paper>
        ))}
      </DialogContent>
      <DialogActions style={{ display: 'contents' }}>
        <Box className={classes.messageInputContainer}>
          <div className={classes.dibtextflex}>
            <TextField
              style={{ border: 'none' }}
              className={classes.messageInput}
              placeholder="Type your message"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              multiline
              rows={1}
              InputProps={{
                style: { border: 'none', boxShadow: 'none' },
                classes: {
                  notchedOutline: classes.notchedOutline,
                },
              }}
            />
            <AttachFileIcon className={classes.attachFilesIcon} />
          </div>
          <IconButton color="primary" onClick={handleSendMessage} aria-label="reply" className={classes.replyButton}>
            <SendOutlinedIcon />
          </IconButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ChatBox;
